export default {
  sidebar: {
    switchSide: 'Alternar lado',
    showSidebar: 'Exibir barra lateral',
    hideSidebar: 'Ocultar barra lateral'
  }
}
